// extracted by mini-css-extract-plugin
export var button = "_fn-4";
export var hasDarkBackground = "_fn-7";
export var hasLightBackground = "_fn-6";
export var iconWrapper = "_fn-0";
export var large = "_fn-2";
export var medium = "_fn-1";
export var small = "_fn-5";
export var xsmall = "_fn-3";